import { type Dayjs } from "dayjs";
import { isElementInViewport } from "utils/dom/is-element-in-viewport";

export function formatDates(start: Dayjs, end: Dayjs) {
  return {
    trip_start_date: start.startOf("day").format("YYYY-MM-DD"),
    trip_end_date: end.startOf("day").format("YYYY-MM-DD"),
  };
}

export function isOnboardingCtaInView(formName?: string) {
  if (!formName) {
    return false;
  }
  return isElementInViewport(
    `form[name="${formName}"] button[type="submit"]:not([hidden])`,
  );
}
